/**
 * Пустое состояние §72: короткий текст + одно действие.
 * Без SaaS-иллюстраций, без emoji (§54).
 */
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-start gap-3 rounded-card border border-dashed border-line px-6 py-10">
      <p className="text-card-title text-content">{title}</p>
      {description ? (
        <p className="max-w-prose text-body text-content-secondary">{description}</p>
      ) : null}
      {action ? <div className="pt-1">{action}</div> : null}
    </div>
  );
}
